import React from 'react'
import { ToastContainer } from 'react-toastify';
import DummyImg from '../../Assets/images/dummyimg.png';
import NumberInput from '../../Component/PhoneInput/phoneInput';
import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import UseProfile from './Hooks/useProfile';

const Profile = () => {
    const {
        uploadImage,
        imageDelete,
        image,
        profiles,
        fileInputRef,
        imageLocation } = UseProfile()
    return (
        <>
            <ToastContainer />
            <section>
                <div className="cus-padd cusheight m-t-3">
                    <h2 className='page-tittle'>
                        Profile
                    </h2>
                    <hr />
                    <div className="tab-content" id="nav-tabContent">
                        {/* Basic Profile Start */}
                        <div className="tab-pane fade show active text-black" id="basic" role="tabpanel" aria-labelledby="basicdetails" tabIndex="0">
                            <div className="text-center mb-4">
                                <img src={image === '' ? DummyImg : imageLocation + image} width={200} height={200} style={{ borderRadius: '50%' }} alt="" />
                                <svg id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '150px', marginLeft: '-55px', fill: 'rgb(76 68 68)' }} width="40" height="35" class="bi bi-camera" viewBox="0 0 16 16">
                                    <path d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1v6zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z" />
                                    <path d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />
                                </svg>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                    <input
                                        accept="image/*"
                                        id="icon-button-file"
                                        type="file"
                                        ref={fileInputRef}
                                        style={{ display: 'none' }}
                                        onChange={(e) => uploadImage(e.target.files[0])}
                                    />
                                    <Button variant="text" sx={{ color: 'black', fontSize: '12px', marginLeft: '10px' }} onClick={() => document.getElementById('icon-button-file').click()} startIcon={<EditIcon />}>Edit</Button>

                                    <br />
                                    {image === '' ? null : (
                                        <Button variant="text" sx={{ color: 'black', fontSize: '12px', marginLeft: '10px' }} onClick={() => imageDelete()} startIcon={<DeleteIcon />}>Delete</Button>
                                    )}
                                </ul>
                            </div>
                            <form className="row g-3 cus-form" onSubmit={profiles.handleSubmit}>
                                <div className="col-md-6">
                                    <div className="mb-3 inputwithicon">
                                        <label className="form-label">Name *</label>
                                        <input type="text" className="form-control bg-light"
                                            name="name"
                                            value={profiles.values.name}
                                            onChange={profiles.handleChange} />
                                        <i className="fa-solid fa-user"></i>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-3 inputwithicon">
                                        <label className="form-label">E-mail Address *</label>
                                        <input type="text" className="form-control bg-light"
                                            disabled
                                            name="email"
                                            value={profiles.values.email}
                                            onChange={profiles.handleChange}
                                        />
                                        <i className="fa-solid fa-envelope"></i>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-3 inputwithicon">
                                        <label className="form-label">Mobile Number *</label>
                                        {/* <input type="text" className="form-control bg-light"
                                            disabled
                                            name="mobileNo"
                                            value={profiles.values.mobileNo}
                                            onChange={profiles.handleChange} /> */}
                                        <NumberInput
                                            width={false}
                                            Require={false}
                                            Name="mobileNo"
                                            HandleChange={profiles}
                                            Value={profiles.values.mobileNo}
                                            disabledInput={true}
                                        />
                                        <i className="fa-solid fa-phone-flip"></i>
                                    </div>
                                </div>
                                <div className="d-grid  col-6  mb-3 justify-content-end">
                                    <button className="btn profile-btn sidebtn px" type='submit'>Update</button>
                                </div>
                            </form>
                        </div>
                        {/* Basic Profile End */}
                    </div>
                </div>

            </section>
        </>
    )
}

export default Profile